import React, { Component } from "react";
import { Spinner, noLoaderUrls } from "../../utils/constants";
import { retrieveToken } from "../../utils/localStorage";
import ReactGA from "react-ga";
import { isMobile } from "../../utils/deviceInfo";

const withLoading = (WrappedComponent, axios) => {
  return class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        loading: false,
        modalHeight: null,
      };
    }

    componentWillMount() {
      // let trackingCode = window.location.hostname.indexOf("devportal")==-1?"UA-148397726-1":"UA-148435617-1"
      // GA DEV  = 148397726
      // GA Prod = 148435617
      // G-J84PQBN6EK
      // ReactGA.initialize("UA-148435617-1");
      ReactGA.initialize("G-J84PQBN6EK");
      let { history } = this.props;
      let { pathname } = window.location;
      if (this.props && this.props.user && history && history.location) {
        let { user } = this.props;
        let organizationId =
          user.profile && user.profile.organizationId
            ? user.profile.organizationId
            : user.organizationId;
        let params = history.location.search;
        if (
          params.length == 0 ||
          (params.length > 0 && params.indexOf(organizationId._id) == -1)
        ) {
          this.props.history.replace({
            pathname,
            search:
              history && history.location && history.location.search
                ? `${history.location.search}&o=${organizationId._id}`
                : `?o=${organizationId._id}`,
          });
        }

        history.listen((location) => {
          ReactGA.set({ page: location.pathname + `?o=${organizationId._id}` });
          ReactGA.pageview(location.pathname + `?o=${organizationId._id}`);
        });
      }
      // console !s.match(/abc|def/g)
      this.reqInterceptor = axios.interceptors.request.use((req) => {
        let noLoader = false;

        if (req && req.data && Object.keys(req.data).length > 0) {
          let { data } = req;
          if (data.noLoader) {
            noLoader = data.noLoader;
          }
        }

        const token = `Bearer ${retrieveToken()}`;
        req.headers.Authorization = token;

        // console.log('bearer_new_req_url---', req.url)
        // console.log('true---', req.url.indexOf("update-user")==-1)
        // console.log('test2---',req.url.indexOf("/users/v1/userListArray")==-1)

        if (req.url && req.url.includes("/orgUserMetaData/v1/metadataupdate")) {
          this.setLoadingState(true);
          return req;
        }
        

        if (
          req.url &&
          req.url.indexOf("getOpenGraphData") == -1 &&
          // req.url.indexOf("/users/v1/fetchUsers") == -1 &&
          req.url.indexOf("change-role") == -1 &&
          req.url.indexOf("/tasks/v1/enterpriseObjective-list") == -1 &&
          req.url.indexOf("notification") == -1 &&
          req.url.indexOf("stories/v1/stories/reaction") == -1 &&
          req.url.indexOf("stories/v1/stories/deleteReaction") == -1 &&
          req.url.indexOf("/stories/v1/stories/removeStory/") == -1 &&
          req.url.indexOf("/getDiversityTypes") == -1 &&
          req.url.indexOf("/tools/comment/") == -1 &&
          req.url.indexOf("update-user") == -1 &&
          req.url.indexOf("/uploadMembersForTrivvy") == -1 &&
          req.url.indexOf("/getPaymentPlans") == -1 &&
          req.url.indexOf("modify-table-layout") == -1 &&
          req.url.indexOf("update-task") == -1 &&
          req.url.indexOf("getDiversityTypes") == -1 &&
          req.url.indexOf("/users/v1/getDiversityTypes") == -1 &&
          req.url.indexOf("/profile") == -1 &&
          req.url.indexOf("/stories/userReactions") == -1 &&
          req.url.indexOf("/users/v1/userListArray") == -1 &&
          req.url.indexOf("getUserEvents") == -1 &&
          !(
            req.url.includes("/search") &&
            !req.url.includes("/searchUsersForListing")
          ) &&
          req.url.indexOf("/recent-event") == -1 &&
          req.url.indexOf("/profile/") == -1 &&
          req.url.indexOf("/getDiversityTypes") == -1 &&
          req.url.indexOf("announcements/v1/getReactions") == -1 &&
          req.url.indexOf("/stories/v1/stories/comment") == -1 &&
          req.url.indexOf("stories/sentiment") == -1 &&
          !(
            req.url.indexOf("organization") &&
            !req.url.includes("/getTrivvySharedEmailPreview") &&
            !req.url.includes("/getTrivvySharedSMSPreview")
          ) &&
          req.url.indexOf("getMailer") == -1 &&
          req.url.indexOf("category/v1/get-topics") == -1 &&
          req.url.indexOf("stories-list") == -1 &&
          req.url.indexOf("findUser") == -1 &&
          req.url.indexOf("linked-charts") == -1 &&
          req.url.indexOf("linked-tools") == -1 &&
          req.url.indexOf("get-items-groups") == -1 &&
          req.url.indexOf("remove-uploads") == -1 &&
          req.url.indexOf("dashboard-charts-update") == -1 &&
          req.url.indexOf("dashboard-charts-data/") == -1 &&
          req.url.indexOf("dashboard-date-change") == -1 &&
          req.url.indexOf("dashboard-archive-chart") == -1 &&
          req.url.indexOf("tasks/v1/unarchiveTask") == -1 &&
          req.url.indexOf("tasks/v1/archiveTask") == -1 &&
          req.url.indexOf("task-list") == -1 &&
          req.url.indexOf("/enterpriseObjective/unlink-action") == -1 &&
          req.url.indexOf("/task/link-action") == -1 &&
          req.url.indexOf("tasks/v1/getSingleTask") == -1 &&
          req.url.indexOf("dashboard/v1/change-chart-order") == -1 &&
          req.url.indexOf("/stories/v1/flagContent/") == -1 &&
          req.url.indexOf("/tasks/v1/unlink-subAction") == -1 &&
          req.url.indexOf("/ai-chat/v1/") == -1 &&
          req.url.indexOf("/dani/v1/answer-feedback") == -1 &&
          req.url.indexOf("/users/v1/get-metrics") == -1 &&
          req.url.indexOf("/stories/v1/share-story") == -1 &&
          req.url.indexOf("toolkit/v1/removeAttachment") == -1 &&
          req.url.indexOf("shareLogs/v1/store-share-data") == -1 &&
          req.url.indexOf("/trivia/v1/edit-trivia") &&
          req.url.indexOf("/trivia/v1/readContentForTrivvy") == -1 &&
          req.url.indexOf("/trivia/v1/uploadTriviaImages") &&
          // req.url.indexOf("/trivia/v1/generate-questions-for-trivia") &&
          req.url.indexOf("/trivia/v1/add-trivia-responses") &&
          req.url.indexOf("/trivia/v1/submit-trivia-responses") &&
          req.url.indexOf("/category/OCCUPATION") == -1 &&
          req.url.indexOf("/category/INDUSTRY") == -1 &&
          req.url.indexOf("/category/SENIORITY") == -1 &&
          req.url.indexOf("/getTrivvyLinkedRewards") == -1 &&
          req.url.indexOf("/get-trivvy-holiday-templates") == -1 &&
          req.url.indexOf("/get-reward-options") == -1 &&
          req.url.indexOf("/generate-questions-for-library") == -1 &&
          req.url.indexOf("/delete-library-question") == -1 &&
          req.url.indexOf("/edit-library-question") == -1 &&
          req.url.indexOf("/get-standard-custom-templeates") == -1 &&
          req.url.indexOf("/get-trivia-insights-summary") == -1 &&
          req.url.indexOf("/get-trivvy-search-keyword") == -1 &&
          req.url.indexOf("/get-trivvy-comments") == -1 &&
          req.url.indexOf("/get-trivia/draft-list") == -1 &&
          req.url.indexOf("/get-custom-rewards") == -1 &&
          req.url.indexOf("/create-trivvy-comment") == -1 &&
          req.url.indexOf("/update-trivvy-comment") == -1 &&
          req.url.indexOf("/generate-library-trivvys") == -1 &&
          req.url.indexOf("/remove-pending-trivvy") == -1 &&
          req.url.indexOf("/generateAndStoreSummaryForLibrarySource") == -1 &&
          req.url.indexOf("/schedule-or-create-trivvy") == -1 &&
          req.url.indexOf("/upload-document-for-trivvy") == -1 &&
          req.url.indexOf("/get-trivia-library") == -1 &&
          req.url.indexOf("/readContentAndCreateQuestions") == -1 &&
          req.url.indexOf("/translateQuestionsData") == -1 &&
          req.url.indexOf("/createTrivvysFinal") == -1 &&
          req.url.indexOf("/upload-trivia-resource") == -1 &&
          req.url.indexOf("/get-trivvy-remind-users") == -1 &&
          req.url.indexOf("?noLoad=true") == -1 &&
          req.url.indexOf("/get-mm-questions-by-date") == -1 &&
          req.url.indexOf("dashboard/v1/dashboard-list") == -1 &&
          req.url.indexOf("/public/get-question-reply") == -1 &&
          req.url.indexOf("/public/generateVideoInstructionsForAMessage") ==
            -1 &&
          req.url.indexOf("/public/getAdditionalVideosForResponse") == -1 &&
          req.url.indexOf("/public/getMoreYoutubeVideosForResponse") == -1 &&
          req.url.indexOf("/public/handleMessageHelpPhotoUpload") == -1 &&
          req.url.indexOf("/getResponsesForSentiments") == -1 &&
          req.url.indexOf("/generateInsightsForTextTrivvyQuestion") == -1 &&
          req.url.indexOf("/generateInsightsForTrivvyNonTextTypeQuestions") ==
            -1 &&
          req.url.indexOf("/news/v1/list") == -1 &&
          req.url.indexOf("/get-score-by-date") == -1 &&
          req.url.indexOf("/group-metrics") == -1 &&
          req.url.indexOf("/dashboard-list") == -1 &&
          req.url.indexOf("/getActionsPieChart") == -1 &&
          req.url.indexOf("/getUniqueActionActivity") == -1 &&
          req.url.indexOf("/getAvgTaskCompletion") == -1 &&
          req.url.indexOf("/get-diversity-calendar-tools") == -1 &&
          req.url.indexOf("/updateSelectedActionsForInsights") == -1 &&
          req.url.indexOf("/generateMessageWording") == -1 &&
          req.url !== "/tasks/v1/task" &&
          noLoader != true
          // &&
        ) {
          this.setLoadingState(true);
        } else {
          this.setLoadingState(false);
        }

        return req;
      });

      this.resInterceptor = axios.interceptors.response.use(
        (res) => {
          // console.log(res)
          // setTimeout(() => this.setState({ loading: false }), 2000);
          this.setLoadingState(false);
          return res;
        },
        (error) => {
          // setTimeout(() => this.setState({ loading: false }), 1000);
          this.setLoadingState(false);
          return Promise.reject(error);
        }
      );
    }

    componentWillUnmount() {
      axios.interceptors.request.eject(this.reqInterceptor);
      axios.interceptors.response.eject(this.resInterceptor);
    }

    setLoadingState = (isLoading) => {
      if (isLoading) {
        const modal = document.querySelector(".modal-body");
        if (modal) {
          this.setState({ loading: true, modalHeight: modal.clientHeight });
        } else {
          this.setState({ loading: true, modalHeight: null });
        }
      } else {
        this.setState({ loading: false, modalHeight: null });
      }
    };

    render() {
      let { loading, modalHeight } = this.state;
      const modal = document.querySelector(".modal-body");

     console.log({Loading:loading})
      return (
        <div>
          {loading ? (
            <img
              src={Spinner}
              style={
                !isMobile ? {
                  position: "fixed",
                  top: modal ? `${modal.offsetTop + modalHeight / 2 - 25}px` : "300px",
                  left: "50%",
                  right: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: "999990000000",
                }:{}
              }
              className="spinner-pos"
            />
          ) : null}
          <div className={loading ? "wrapped-component-on-loading" : " "}>
            <WrappedComponent {...this.props} />
          </div>
        </div>
      );
    }
  };
};

export default withLoading;
